import { Stack } from "@mui/material";
import EquationItem from "src/shared/components/equation-item";
import { IMoneyOwnData } from "src/types/dashboard";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utils";

const Equations = ({ data }: { data: IMoneyOwnData }) => {
  const { t } = useTranslation("dashboard");

  const EquationItems = [
    {
      title: `${t("sar")} ${formatNumber(data.gross_sale)}`,
      subtitle: t("netSalesWithTax"),
      subtitleColor: "#98A2B3",
      operator: "-",
      tooltip: `${t("netSales")} + ${t("tax")}`
    },
    {
      title: `${t("sar")} ${formatNumber(data.sales_tax)}`,
      subtitle: t("salesTax"),
      subtitleColor: "#98A2B3",
      operator: "+",
      tooltip: ""
    },

    {
      title: `${t("sar")} ${formatNumber(data.refund_tax)}`,
      subtitle: t("refundTax"),
      subtitleColor: "#98A2B3",
      operator: "=",
      tooltip: t("TotalTaxPaid")
    },

    {
      title: `${t("sar")} ${formatNumber(data.money_own)}`,
      subtitle: t("moneyOwn"),
      subtitleColor: "#98A2B3",
      tooltip: ""
    },
  ];
  return (
    <Stack py={"10px"} bgcolor={"#EAECF0"} direction={"row"} flexWrap={"wrap"}>
      {EquationItems.map((item) => (
        <EquationItem
          title={item.title}
          subtitle={item.subtitle}
          subtitleColor={item.subtitleColor}
          operator={item.operator}
          tooltip={item.tooltip}
        />
      ))}
    </Stack>
  );
};
export default Equations;
